module.exports = __webpack_public_path__ + "img/icon-comfy.7b6a89b0.svg";